import styled from "@emotion/styled";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100%;
  padding: 0 20px;

  .component-title-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 45px;
    gap: 16px;

    .component-title-txt {
      font-family: "Roboto Condensed";
      font-size: 96px;
      line-height: 112px;
      font-weight: bold;
      text-align: center;
      color: #ffffff;
      text-transform: uppercase;

      @media (max-width: 900px) {
        font-size: 48px;
        line-height: 56px;
      }
    }

    .component-subtitle-txt {
      font-family: "Roboto Condensed";
      font-size: 32px;
      line-height: 37px;
      opacity: 0.5;
      font-weight: 600;
      text-align: center;
      color: #ffffff;
      text-transform: uppercase;

      @media (max-width: 900px) {
        font-size: 16px;
        line-height: 18px;
      }
    }

    .component-disclaimer-txt {
      font-family: "Roboto Condensed";
      font-size: 12px;
      line-height: 14px;
      opacity: 0.5;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      text-transform: uppercase;
    }
  }

  .data-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    height: ${(props) => (props?.dataLength === 0 ? "100vh" : "auto")};
    width: 100%;
  }

  @media (max-width: 900px) {
    padding: 0 16px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #006f3d;
  width: 100%;
  max-width: 1200px;
  border: 1px solid
    ${(props) => (props.hasWinner ? "#dae753" : "rgba(255,255,255,0.5)")};
  border-radius: 16px;
  padding: 24px;
  position: relative;
  z-index: 1;

  .backgroundImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.4;
    z-index: -1;
    border-radius: 16px;
  }

  .data-infos-container {
    flex: 1%;
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }
`;

export const SweepstakeInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .sweepstake-infos {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    opacity: ${(props) => (props.hasWinner ? 1 : 0.5)};

    .icon {
      width: 32px;
      height: 32px;
    }

    .sweepstake-position-txt {
      font-family: "Roboto Condensed";
      font-size: 24px;
      line-height: 28px;
      font-weight: 600;
      color: #ffffff;
      text-transform: uppercase;
      text-align: center;

      @media (max-width: 900px) {
        font-size: 24px;
        line-height: 28px;
      }
    }

    .sweepstake-status {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      text-align: center;

      .sweepstake-status-txt {
        font-family: "Roboto Condensed";
        font-size: 16px;
        line-height: 18px;
        font-weight: 500;
        color: #006437;
        padding: 10px 16px;
        border-radius: 999px;
        background: ${(props) => (props.hasWinner ? "#e1c683" : "#FFFFFF")};
        text-transform: uppercase;
        text-align: center;

        @media (max-width: 900px) {
          font-size: 16px;
          line-height: 18px;
          padding: 8px 12px;
        }
      }
    }
  }
  .sweepstake-link {
    button {
      background-color: transparent;
      border: none;
      cursor: pointer;
    }

    span {
      font-family: "Roboto Condensed";
      font-size: 16px;
      line-height: 18px;
      font-weight: 500;
      text-align: center;
      color: #dae753;
      text-decoration: underline;
      text-align: center;
    }
  }
`;

export const ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-end;
  gap: 32px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }

  .product-infos {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    padding: 32px;

    @media (max-width: 1000px) {
      padding: 16px;
    }

    .product-img {
      width: 100%;
      max-width: 252px;
      height: 162px;

      &.apartamento {
        width: 100%;
        height: 338px;
      }
      &.tv {
        width: 100%;
        height: auto;
      }
    }

    .product-title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 8px;

      .product-title-txt {
        font-family: "Roboto Condensed";
        font-size: 28px;
        line-height: 32px;
        font-weight: 600;
        color: #ffffff;
        text-transform: uppercase;
        text-align: center;

        @media (max-width: 900px) {
          font-size: 24px;
          line-height: 28px;
        }
      }

      .product-winners-quantity {
        font-family: "Roboto";
        font-size: 16px;
        line-height: 18px;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.5;
        text-align: center;

        @media (max-width: 900px) {
          font-size: 16px;
          line-height: 18px;
        }
      }
    }
  }
  .sweepstake-link {
    button {
      background-color: transparent;
      border: none;
      cursor: pointer;
    }

    span {
      font-family: "Roboto Condensed";
      font-size: 16px;
      line-height: 18px;
      font-weight: 500;
      text-align: center;
      color: #dae753;
      text-decoration: underline;
      text-align: center;
    }
  }
`;

export const WinnersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 32px;
  padding: 0 270px;

  @media (max-width: 900px) {
    padding: 0 10px;
  }

  .winners-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
  }

  thead {
    background-color: #068049;
    border-bottom: none;
    border-radius: 16px;
  }

  th {
    font-family: "Roboto";
    font-size: 18px;
    line-height: 21px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    padding: 15px 12px;
    text-align: center;
  }

  td {
    font-family: "Roboto ";
    font-size: 16px;
    line-height: 18px;
    font-weight: 500;
    text-align: center;
    padding: 17px 12px;
    border-bottom: 1px solid #33835f;
    color: #ffffff;
    text-align: center;
  }

  .winners-table thead tr th:first-child {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
  }

  .winners-table thead tr th:last-child {
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
  }
`;
